(function () {
  // Update email placeholder — runs on all viewports
  function updatePlaceholder() {
    var inputs = document.querySelectorAll('.footer-content input[type="email"], .footer-content .email-signup__input');
    inputs.forEach(function(input) {
      input.setAttribute('placeholder', 'Enter your email');
    });
    var labels = document.querySelectorAll('.footer-content .field__label');
    labels.forEach(function(label) {
      label.textContent = 'Enter your email';
    });
    return inputs.length > 0;
  }

  // Try immediately, then retry with observer
  if (!updatePlaceholder()) {
    var placeholderAttempts = 0;
    var placeholderTimer = setInterval(function () {
      placeholderAttempts++;
      if (updatePlaceholder() || placeholderAttempts > 30) clearInterval(placeholderTimer);
    }, 200);
  }

  // Mobile accordion — only on small screens
  var mq = window.matchMedia('(max-width: 749px)');
  if (!mq.matches) return;

  function initAccordion() {
    var footer = document.querySelector('.footer-content');
    if (!footer) return false;

    var blocks = footer.querySelectorAll(':scope > .group-block');
    if (!blocks.length) return false;

    var applied = false;

    blocks.forEach(function (block) {
      if (block.classList.contains('footer-accordion')) return;

      var content = block.querySelector('.group-block-content');
      if (!content) return;

      var children = content.children;
      if (children.length < 2) return;

      // Skip newsletter (has form/input)
      if (block.querySelector('form, input[type="email"]')) return;

      // Skip brand group (no links in any child)
      var totalLinks = 0;
      for (var i = 1; i < children.length; i++) {
        totalLinks += children[i].querySelectorAll('a').length;
      }
      if (totalLinks === 0) return;

      var heading = children[0];
      if (heading.textContent.trim().length > 30) return;

      // Apply accordion
      block.classList.add('footer-accordion');
      heading.classList.add('footer-accordion__heading');
      heading.setAttribute('role', 'button');
      heading.setAttribute('aria-expanded', 'false');
      heading.tabIndex = 0;

      // Add plus icon inside the innermost text element
      var textEl = heading.querySelector('p') || heading;
      textEl.style.display = 'flex';
      textEl.style.justifyContent = 'space-between';
      textEl.style.alignItems = 'center';
      textEl.style.width = '100%';
      textEl.style.cursor = 'pointer';
      var icon = document.createElement('span');
      icon.className = 'footer-accordion__icon';
      icon.textContent = '+';
      textEl.appendChild(icon);

      // Mark body items for collapse
      for (var j = 1; j < children.length; j++) {
        children[j].classList.add('footer-accordion__body');
      }

      heading.addEventListener('click', function () {
        var exp = this.getAttribute('aria-expanded') === 'true';
        this.setAttribute('aria-expanded', String(!exp));
        block.classList.toggle('footer-accordion--open');
      });

      heading.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.click();
        }
      });

      applied = true;
    });

    return applied;
  }

  // Try immediately
  if (initAccordion()) return;

  // Retry on DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      if (initAccordion()) return;
      startObserver();
    });
  } else {
    startObserver();
  }

  function startObserver() {
    var attempts = 0;
    var timer = setInterval(function () {
      attempts++;
      if (initAccordion() || attempts > 30) clearInterval(timer);
    }, 200);
  }
})();
